import { render, staticRenderFns } from "./OfferBtns.vue?vue&type=template&id=051e011d&"
import script from "./OfferBtns.vue?vue&type=script&lang=js&"
export * from "./OfferBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports